module.exports = __webpack_public_path__ + "img/screen1.691dd754.svg";